
export const useStyles = () => {
    return {
        styles: {
            container: {
                display: "flex",
                height: "100%"
            },
            btn: {
                flex: 1,
                lineHeight: 1.3,
                width: "max-content"
            },
            inputContainer: {
                display: "flex",
                flexWrap: "wrap",
                rowGap: "8px"
            },
            footer: {
                display: "flex",
                gap: "16px",
                justifyContent: "flex-end",
                borderTop: "1px solid #777",
                marginTop: "24px",
                paddingTop: "24px",
                paddingRight: "24px"
            },
            content: {
                display: "flex",
                flexDirection: "column",
                rowGap: "16px",
                marginTop: "8px"
            },
            autocomplete: {
                '& .MuiTextField-root': {
                    width: "100%"
                }
            },
            date: {
                flexGrow: 1
            }
        }
    }
}